import { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";

const Products = () => {
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const products = [
    {
      title: "DX - Evaporator Coil",
      description:
        "The coil responsible for absorbing heat from the indoor air in direct expansion (DX) air conditioning systems.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgY8H6D2BPW52NQ-BeEYTi6HWl4h84oKR88K2vieSy5aVc4zn3Z83hbmNFEK2ONvhHb-6r10tHjJhmxidMWBVHPugJdvKpuQbgSYQlIEf8l2dIeXS3TOuDmvKSJYgqJFyttLYLoIIQz-XgiGVIBk_2_I8IAKxMIHfuykNboXB-hSaDBHBDLu03w1cfYqXg/s320/DX.png",
    },
    {
      title: "Condenser Coil",
      description:
        "A component in HVAC systems that releases absorbed heat from the refrigerant to the outside air, facilitating the cooling process.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg3-dwkNBseeQNfsGqO48QntbpOrx28WD_WSgqWtyRS5IEar7GawXrzgcENWPzhO3UbyKsIJEBbgFzgmZz4FOZ0WGq5UxJFjebi1rCaBKl89svhAJE9tgC0eYpGKWbQ6RrJ60J4qlOWCaE-fx71Gm2dyJXxIGSD7PxJWeD3rN0PKSYCKXFaNHXfQSi_CWo/s350/CondenserCoil.png",
    },
    {
      title: "Counter Freezer Evaporator coil",
      description:
        "The coil that cools down the air inside a freezer unit, essential for maintaining low temperatures for food preservation.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiDtwhMej-tPo1VBWCwILC-ScjQPW-sx9_4BeO75mfgTF5oldZ_KeDHZJ36rq6-ypd3gOSfvfKldHZ7InCOZ-C-HZez7AX_IIl1PGTGFdsfJASfiVEHcMcJ7feTLtixSJga5sZTa_dVs5RDIWFuQVRSNp0MetH-jhelu6TcLRMzBrTvJhJNK4IQiqrd04s/s350/Counter.png",
    },
    {
      title: "Condenser Unit",
      description:
        "The component that releases heat from the refrigerant, crucial for cooling down the air in air conditioning systems.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgzaNs_AEwHge9jiTLQIltJw16DADu6t9f9z70KSDO5N1hd9efqynR-hgngxknOPFMQDG2NK8f24GA0PWmDrNfFYOC6qjIDfZARNffwB8RmoW9sgDhFBet0SXzxnVLRYeS0JgAtGOyHxZd2OyZalwTGNygfGOA-CgHKSXMgTW_PK3LG2WgZJ_saIIefcMY/s320/Water.png",
    },
    {
      title: "Water/Milk Chiller Condenser coil",
      description:
        "A coil that helps to cool water or milk by transferring heat to the surrounding air.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhtfjWPuKI1u27CVyDppoAGdizlsi9sy4t9DrFtKq4ws8nvRjyXBF6xYFsy3sCL4UACrtkFixL0ActJ7IYBk_r3eoR6SWPOveKTDJtBiJqrKyGFGFPHhYa5Y27V0Lqhmur4dfOAnlqyKKduwk4EUHNvfkLDAbrmGc1cfIIluCZ2ScdjZzUb9PLVzhhEsaw/s320/Condenser.png",
    },
    {
      title: "Low Temperature Evaporator Coils",
      description:
        "Coils designed to absorb heat at lower temperatures, typically used in refrigeration systems for preserving perishable goods.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEitNMu_wbwyoUbQbr2gxgu6feM5coSuuy0dW4ooZf5caxsEoGkPzYBY_igm4mkJ4KestnIaieAYVrrrrEGhst3lxL8ZA6P6OtlgR_NN5GCdqwPW6zSeArE7U_DCq75HJX3m83VECaykgScgD3FiD75ypiHBCNLnoqTOC1pynNtvFTayY0Tm8EfHqPnTQUM/s350/Low.png",
    },
    {
      title: "Chilled Water Coilsy",
      description:
        "Coils that cool down water by removing heat, commonly found in HVAC systems for air conditioning.",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjbOVKlLf7YVmBYlDbsffEUYftk1pcRtZSy_X7zXcY_TvNaQ2z6VLFBhyphenhyphenD1vwlMY3YZNg26w6mPqqoWhVHh9sB6BnTbmDdzsj2vj5S7Sqyon-KuJgUZkstpN7eF8b_Vj8nz7YRIX1gO5sxA41m6GEnOKUvioVTNaccadCrPZWvlIhn6GTyGwuQOkDfZeB8/s320/Chilled.png",
    },
  ];

  const CARD_WIDTH = 320;

  const scroll = (dir) => {
    if (!sliderRef.current) return;

    sliderRef.current.scrollBy({
      left: dir === "left" ? -CARD_WIDTH : CARD_WIDTH,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollLeft = sliderRef.current.scrollLeft;
      const index = Math.round(scrollLeft / CARD_WIDTH);
      setActiveIndex(index);
    };

    const el = sliderRef.current;

    el?.addEventListener("scroll", handleScroll);

    return () => el?.removeEventListener("scroll", handleScroll);
  }, []);

  const goToSlide = (i) => {
    sliderRef.current.scrollTo({
      left: i * CARD_WIDTH,
      behavior: "smooth",
    });
  };

  return (
    <section className="py-14 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold text-[#256ab7]">
            Our Products
          </h2>

          <p className="text-gray-500 mt-4 leading-7">
            Coolwell Coils delivers premium HVAC coil solutions
            designed for durability, efficiency, and long-term
            performance in industrial and commercial applications.
          </p>
        </div>

        {/* Arrows */}
        <div className="flex justify-end gap-3 mt-10">
          <button
            onClick={() => scroll("left")}
            className="w-11 h-11 rounded-full bg-gray-100 hover:bg-black hover:text-white transition-all"
          >
            ←
          </button>

          <button
            onClick={() => scroll("right")}
            className="w-11 h-11 rounded-full bg-gray-100 hover:bg-black hover:text-white transition-all"
          >
            →
          </button>
        </div>

        {/* Slider */}
        <div
          ref={sliderRef}
          className="flex gap-6 mt-8 overflow-x-auto scroll-smooth snap-x snap-mandatory no-scrollbar"
          style={{
            scrollbarWidth: "none",
          }}
        >
          {products.map((item, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.3 }}
              className="min-w-[320px] bg-slate-100 rounded-3xl overflow-hidden snap-start shadow-sm"
            >
              <div className="overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-64 object-cover hover:scale-110 transition duration-500"
                />
              </div>

              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {item.title}
                  </h3>

                </div>

                <p className="text-gray-500 text-sm leading-6 mt-3">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {products.map((_, i) => (
            <button
              key={i}
              onClick={() => goToSlide(i)}
              className={`rounded-full transition-all duration-300 ${
                activeIndex === i
                  ? "w-7 h-2 bg-black"
                  : "w-2 h-2 bg-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;